(function AdzukiSelectFiles($, Adzuki) {
	'use strict';

	const component = {
		emits : ['selected-media', 'component-event'],
		inject: {
			formatDuration: {
				default: () => undefined
			},
			getMediaSrcString: {
				default: () => undefined
			},
			formatFileSize: {
				default: () => undefined
			},
			fileIcon: {
				default: () => undefined
			},
			formatDate: {
				default: () => undefined
			},
			getSectionInfo: {
				default: () => undefined
			},
			openToast: {
				default: () => undefined
			},
			normalizeExtension: {
				default: () => undefined
			},
			sendMediaToParent: {
				default: () => undefined
			},
			statusAction: {
				default: () => undefined
			},
			fileNameFromPath: {
				default: () => undefined
			},
			mediaAssetSrc: {
				default: () => (value) => {
					if (!value) {
						return '';
					}

					if ((/^https?:\/\//i).test(value)) {
						return value;
					}

					return value;
				}
			},
			onPrivateMediaImageError: {
				default: () => (item) => {
					Adzuki.MediaUrls.fallbackToProxy(item);
				}
			},
			onPrivateMediaThumbnailError: {
				default: () => (item) => {
					Adzuki.MediaUrls.fallbackThumbnailToProxy(item);
				}
			}
		},
		props: {
			media: {
				type    : Array,
				required: true
			},
			sectionInfo: {
				type: Object,
			},
			loading: {
				type   : Boolean,
				default: false
			},
			showUploadTab: {
				type   : Boolean,
				default: true
			},
			showSelectAll: {
				type   : Boolean,
				default: true
			}
		},
		template: '#adzuki-select-files',
		data() {
			return {
				filteredMedia: [],
				// MEDIA-340: the sort chosen in the menu, re-applied whenever the filter
				// hands over a new list (null until one is chosen: the list keeps the
				// order it loaded in)
				currentSort  : null,
				layout       : 'grid-layout',
				sortOptions  : [
					{
						key        : 'title',
						label      : 'Title',
						description: 'Media Hub Title'
					},
					{
						key        : 'name',
						label      : 'File Name',
						description: ''
					},
					{
						key        : 'date',
						label      : 'Upload Date/Time',
						description: ''
					},
				],
				showDetails     : false,
				selectedMedia   : {},
				selectedRowIndex: 0,
				itemsPerRow     : 4,
				uploadProps     : {},
				resizeObserver  : null,
				resizeTimeout   : null,
				actionSelect    : [],
				bulkAction      : 'default',
				showConfirm     : false,
				confirmMessage  : '',
				activeTab       : 'select',
				visibleRowsCount: 3,
				loadMore        : 3,
				viewElement     : null,
				mdAndLess       : false
			};
		},
		computed: {
			allGroupedItems() {
				if (!this.filteredMedia) {
					console.error('filteredMedia is undefined');
					return [];
				}

				const rows = [];
				for (let i = 0; i < this.filteredMedia.length; i += this.itemsPerRow) {
					rows.push(this.filteredMedia.slice(i, i + this.itemsPerRow));
				}
				return rows;
			},
			groupedItems() {
				return this.allGroupedItems.slice(0, this.visibleRowsCount);
			},
			hasMoreRows() {
				return this.visibleRowsCount < this.allGroupedItems.length;
			},
			remainingRowsCount() {
				return Math.max(0, this.allGroupedItems.length - this.visibleRowsCount);
			},
			hasResizeDimensions() {
				return Number(this.sectionInfo.resize_width) > 0;
			},
			shownItems() {
				let shownItems = this.itemsPerRow * this.visibleRowsCount;

				if (shownItems > this.filteredMedia.length) {
					return this.filteredMedia.length;
				}

				return shownItems;

			}
		},
		methods: {
			// a file's tags as at most three pills (MEDIA-327)
			tagPills(tags) {
				return Adzuki.MediaTagPills.split(tags);
			},
			// "+N more": close its tooltip before the details open over it (MEDIA-327)
			moreTagsClick(event, item, rowIndex) {
				Adzuki.MediaTagPills.hideTip(event.currentTarget);
				this.viewDetails(item, rowIndex);
			},
			tabToggle(tab) {
				if (tab === 'select') {
					this.activeTab = 'select';
				} else {
					this.activeTab = 'upload';
				}
			},
			setFilteredMedia(medias) {
				console.log('setFilteredMedia select files', medias);
				const detailsOpen = this.showDetails;
				const selectedId  = this.selectedMedia?.id;

				this.filteredMedia = medias;

				// MEDIA-340: a filter change used to drop the sort the menu still showed
				if (this.currentSort) {
					this.handleSort(this.currentSort);
				}

				this.resetPagination();

				if (detailsOpen && selectedId) {
					const found = this.findMediaRowIndex(selectedId);

					if (found.rowIndex >= 0) {
						this.selectedRowIndex = found.rowIndex;
						this.selectedMedia    = found.media;
						this.ensureRowVisible(found.rowIndex);
					}
				}
			},
			toggleLayout(layoutType) {
				this.layout = layoutType;

				if (this.layout === 'list-layout') {
					this.itemsPerRow      = 1;
					this.visibleRowsCount = 15;
					this.loadMore         = 10;
					localStorage.setItem('item-layout', 'list-layout');
				} else {
					this.itemsPerRow      = 4;
					this.visibleRowsCount = 3;
					localStorage.setItem('item-layout', 'grid-layout');
				}
			},
			handleSort(sortInfo) {
				const { key, direction } = sortInfo;

				this.currentSort = {
					key      : key,
					direction: direction,
				};

				const getValue = (item) => {
					switch (key) {
						case 'title':
							return item.title ? item.title.toLowerCase() : '';
						case 'name': {
							const fileName = (item.actual_file_name && item.actual_file_name.length > 1)
								? item.actual_file_name
								: (item.original_file_name || '');

							return fileName.toLowerCase();
						}
						case 'date':
							return item.created ? new Date(item.created) : new Date(0);
						default:
							return '';
					}
				};

				// a sorted copy: the filter hands over its own array (MEDIA-340)
				this.filteredMedia = [...this.filteredMedia].sort((a, b) => {
					const valA = getValue(a);
					const valB = getValue(b);

					let comparison = 0;

					if (key === 'date') {
						comparison = valA - valB;
					} else {
						comparison = valA.toLowerCase().localeCompare(valB.toLowerCase());
					}

					return direction === 'asc' ? comparison : -comparison;
				});
			},
			handleSelectedMedia(selectedMedia) {
				const uploadedIds = (selectedMedia && Array.isArray(selectedMedia.media_id))
					? selectedMedia.media_id
					: [];

				// A batch upload sends the section with every file, so it arrives already
				// linked and carries an array of ids. It has no 'success' status, so the
				// fallback below would collapse the whole array into one selectMediaFile
				// post and attach only the first file.
				// The details panel already linked its file too, hence the status check.
				if (
					uploadedIds.length > 1 ||
					(selectedMedia && selectedMedia.status === 'success' && selectedMedia.media_id)
				) {
					if (Number(this.sectionInfo?.vue_app) === 1) {
						this.$emit('selected-media', selectedMedia);
						this.$emit('component-event', selectedMedia);
						return;
					}

					this.sendMediaToParent(selectedMedia);
					return;
				}

				const media = selectedMedia;

				// a single upload now arrives as a one element array
				media.id = uploadedIds.length === 1 ? uploadedIds[0] : media.media_id;

				this.selectMedia(media, this.selectedRowIndex);
			},
			viewDetails(media, rowIndex) {
				this.viewElement = 'details';
				this.openDetails(media, rowIndex);
			},
			openDetails(media, rowIndex) {
				this.ensureRowVisible(rowIndex);
				this.selectedMedia    = media;
				this.showDetails      = true;
				this.selectedRowIndex = rowIndex;

				this.$nextTick(() => {
					this.ensureRowVisible(this.selectedRowIndex);

					const detailsPanel = document.querySelector('.details-panel');

					if (detailsPanel) {
						detailsPanel.scrollIntoView({ behavior: 'smooth' });
					}
				});
			},
			ensureRowVisible(rowIndex) {
				if (rowIndex === null || rowIndex === undefined || rowIndex < 0) {
					return;
				}

				this.visibleRowsCount = Math.max(this.visibleRowsCount, rowIndex + 1);
			},
			findMediaRowIndex(mediaId) {
				const targetId = String(mediaId);

				for (let rowIndex = 0; rowIndex < this.allGroupedItems.length; rowIndex++) {
					const row = this.allGroupedItems[rowIndex];
					const match = row.find(m => String(m.id) === targetId);

					if (match) {
						return {
							media: match,
							rowIndex
						};
					}
				}

				return {
					media   : null,
					rowIndex: -1
				};
			},
			needsPopFormForPending(data) {
				return Number(this.sectionInfo?.needs_approval) === 1 && Number(data.matches_found) === 1;
			},
			openPendingApprovalDetails(media, rowIndex = null) {
				let resolvedMedia = media;
				let resolvedRowIndex = rowIndex;

				if (resolvedRowIndex === null || resolvedRowIndex === undefined || resolvedRowIndex < 0) {
					const found = this.findMediaRowIndex(media.id || media.media_id);

					if (found.rowIndex >= 0) {
						resolvedMedia    = found.media;
						resolvedRowIndex = found.rowIndex;
					} else {
						resolvedRowIndex = 0;
					}
				}

				this.activeTab     = 'select';
				this.viewElement   = 'pop-form';
				this.openDetails(resolvedMedia, resolvedRowIndex);
			},
			async handlePendingApproval(data) {
				const mediaId = data.media_id;

				if (!mediaId) {
					return;
				}

				if (this.needsPopFormForPending(data)) {
					const found = this.findMediaRowIndex(mediaId);

					if (found.media) {
						this.openPendingApprovalDetails({
							...found.media,
							status: 'pending'
						}, found.rowIndex);
						return;
					}

					const formData = new FormData();
					formData.append('media_ids', JSON.stringify([mediaId]));

					try {
						const response = await fetch(`${this.$baseUri}/Media/getMediaItemsById`, {
							method: 'POST',
							body  : formData
						});

						if (!response.ok) {
							throw new Error(`Failed to fetch uploaded media: ${response.statusText}`);
						}

						const mediaItems = await response.json();
						const media = Array.isArray(mediaItems) ? mediaItems[0] : null;

						if (media) {
							this.openPendingApprovalDetails({
								...media,
								status: 'pending'
							});
						}
					} catch (error) {
						console.error('Error opening pending approval details:', error);
					}

					return;
				}

				if (this.sectionInfo.vue_app === 1) {
					this.$emit('selected-media', data);
					this.$emit('component-event', data);
				} else {
					this.sendMediaToParent(data);
				}
			},
			determineFileSelect(media, rowIndex) {
				if (media.status === 'pending' && Number(this.sectionInfo?.needs_approval) === 1) {
					return;
				}

				if (this.hasResizeDimensions) {
					if (this.sectionVersionNeedsCrop(media)) {
						this.viewElement = 'cropper';
						this.openDetails(media, rowIndex);
					} else {
						this.selectMedia(media, rowIndex);
					}
				} else {
					this.selectMedia(media, rowIndex);
				}
			},
			/**
			 * True when this section needs a cropped version and the media does not
			 * yet have a distinct section object (missing version, or metadata-only
			 * row that still points at the library remote_url).
			 */
			sectionVersionNeedsCrop(media) {
				if (!this.sectionInfo || !this.hasResizeDimensions) {
					return false;
				}

				const sectionId = Number(this.sectionInfo.id);

				if (Number(media.media_section_id) === sectionId) {
					return false;
				}

				const version = (media.versions || []).find(
					(item) => Number(item.media_section_id) === sectionId
				);

				if (!version) {
					return true;
				}

				const versionUrl = String(version.remote_url || '').split('?')[0];
				const parentUrl  = String(media.remote_url || '').split('?')[0];

				return !versionUrl || versionUrl === parentUrl;
			},
			selectMedia(media, rowIndex = null) {
				let url = this.$baseUri + '/Media/selectMediaFile/';

				const formData = new FormData();
				formData.append('id', media.id);
				formData.append('section', this.sectionInfo.internal_name);

				// Pass the effective needs_approval (after URL override on sectionInfo)
				// so the server can overwrite the DB section flag for this request.
				if (typeof this.$needsApproval === 'boolean') {
					formData.append('needs_approval', Number(this.sectionInfo?.needs_approval) === 1 ? '1' : '0');
				}

				fetch(url, {
					method: 'POST',
					body  : formData,
				})
					.then(response => response.json())
					.then(data => {
						if (data.status === 'pending') {
							const updatedMedia = {
								...media,
								status: data.status
							};
							const mediaIndex = this.media.findIndex(item => String(item.id) === String(media.id));

							if (mediaIndex !== -1) {
								this.media[mediaIndex] = {
									...this.media[mediaIndex],
									status: data.status
								};
							}
							if (this.needsPopFormForPending(data)) {
								this.openPendingApprovalDetails(updatedMedia, rowIndex);
								return;
							}

							if (this.sectionInfo.vue_app === 1) {
								this.$emit('selected-media', data);
								this.$emit('component-event', data);
							} else {
								this.sendMediaToParent(data);
							}

							return;
						}

						if (this.sectionInfo.vue_app === 1) {
							this.$emit('selected-media', data);
							this.$emit('component-event', data);
						} else {
							this.sendMediaToParent(data);
						}
					})
					.catch(error => {
						console.error('Error:', error);
					});
			},
			selectAllMedia() {
				if (this.actionSelect.length > this.sectionInfo.upload_limit) {
					this.openToast('error', `You may only upload ${this.sectionInfo.upload_limit} files. Please deselect ${this.actionSelect.length - this.sectionInfo.upload_limit} files.`);
					return;
				}

				let url = this.$baseUri + '/Media/selectAllMediaFiles/';

				const selected = (this.actionSelect || [])
					.map(item => (item && typeof item === 'object') ? item : this.media.find(m => String(m.id) === String(item)))
					.filter(Boolean);

				const selectedIds         = [];
				const needsSectionVersion = [];

				const sectionId = String(this.sectionInfo.id);

				selected.forEach(m => {
					if (m.type === 'image' && this.hasResizeDimensions) {
						const fromThisSection = String(m.media_section_id) === sectionId;
						const hasVersionForSection = (m.versions || []).some(v => String(v.media_section_id) === sectionId);

						if (fromThisSection || hasVersionForSection) {
							selectedIds.push(m.id);
						} else {
							needsSectionVersion.push(m);
						}
					} else {
						selectedIds.push(m.id);
					}
				});

				const formData = new FormData();
				formData.append('media_ids', JSON.stringify(selectedIds));
				formData.append('section', this.sectionInfo.internal_name);

				// Pass the effective needs_approval (after URL override on sectionInfo)
				// so the server can overwrite the DB section flag for this request.
				if (typeof this.$needsApproval === 'boolean') {
					formData.append('needs_approval', Number(this.sectionInfo?.needs_approval) === 1 ? '1' : '0');
				}

				 fetch(url, {
					method: 'POST',
					body  : formData,
				})
					.then(response => response.json())
					.then(data => {
						if (this.sectionInfo.vue_app === 1) {
							this.$emit('selected-media', data);
							this.$emit('component-event', data);
						} else {
							this.sendMediaToParent(data);
						}
					})
					.catch(error => {
						console.error('Error:', error);
					});
			},
			selectionLimitReached(item) {
				const limit = Number(this.sectionInfo.upload_limit);

				return limit > 0
					&& this.actionSelect.length >= limit
					&& !this.actionSelect.includes(item);
			},
			updateItemsPerRow() {
				// Clear existing timeout
				if (this.resizeTimeout) {
					clearTimeout(this.resizeTimeout);
				}

				// Set new timeout to debounce the update
				this.resizeTimeout = setTimeout(() => {
					const gridElement = document.getElementById('media-list-container');
					if (gridElement) {
						const gridStyle = window.getComputedStyle(gridElement);
						const columns = gridStyle.gridTemplateColumns.split(' ').length;
						this.itemsPerRow = columns;
					}
				}, 250); // Wait 250ms after last resize before updating
			},
			saveFavorite(media) {
				let set = 0;

				if (media.favorite === "1") {
					set = 0;
				} else {
					set = 1;
				}

				const url = `${this.$baseUri}/Media/updateFavorite/${media.id}/${set}`;

				fetch(url)
					.then(response => {
						if (!response.ok) {
							throw new Error(`Error Updating Media Item: ${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						// Update the item in the main media array to keep them in sync
						const mainMediaItem = this.media.find(item => item.id === data.media_id);

						if (mainMediaItem) {
							mainMediaItem.favorite = String(set);
						}

						this.openToast('success', `Media Item ${set === 1 ? '' : 'un'}favorited successfully`);
					})
					.catch(error => {
						this.openToast('error', 'Error Updating Media Item: '+ error);
					});
			},
			stageAllMedia() {
				if (this.actionSelect.length === this.media.length) {
					this.actionSelect = [];
				} else {
					this.actionSelect = this.media.map(item => item.id);
				}
			},
			confirmDelete() {
				console.log('confirm Action');
			},
			cancelDelete() {
				this.showConfirm   = false;
				this.mediaToDelete = null;
			},
			loadMoreRows() {
				this.visibleRowsCount = Math.min(
					this.visibleRowsCount + this.loadMore,
					this.allGroupedItems.length
				);
			},
			resetPagination() {
				this.visibleRowsCount = 3;
			},
			closeDetails() {
				this.showDetails = false;
				this.viewElement = null;

				this.$nextTick(() => {
					window.parent.postMessage({
						type    : 'scrollModalToTop',
						targetId: this.$targetId
					}, '*');
				});
			},
			getGridCount(item) {
				if (item.media_tags && item.media_tags.length > 0) {
					return '4';
				}

				return '3';
			},
			updateStatusText(status) {
				switch (status) {
					case 'restricted':
						return 'Approved - Limited';
					case 'pending':
						return 'Pending Unlimited Approval';
					case 'approved':
						return 'Approved - Unlimited';
					default:
						return status;
				}
			},
			updateMediaStatus(media) {
				const url = `${this.$baseUri}/Media/updateMediaItem`;

				const formData = new FormData();
				formData.append('media', media);

				fetch(url, {
					method: 'POST',
					body  : formData
				})
					.then(response => {
						if (!response.ok) {
							throw new Error(`Failed to update media item: ${response.statusText}`);
						}
						return response.json();
					})
					.then(result => {
						this.openToast('success', `Successfully updated ${this.media.title}`);
					})
					.catch(error => {
						console.error('Error deleting files:', error);
						this.openToast('error', 'An error occurred while deleting files');
						this.showConfirm = false;
					});
			}
		},
		watch: {
			sortOption(newValue) {
				this.handleSort(newValue);
			},
			bulkAction(newValue) {
				this.handleBulkAction(newValue);
			}
		},
		mounted() {
			if (this.$tab) {
				this.activeTab = this.$tab;
			}


			this.resizeObserver = new ResizeObserver(() => {
				this.updateItemsPerRow();
				this.mdAndLess = window.innerWidth <= 768;

			});

			const gridElement = document.getElementById('media-list-container');

			if (gridElement) {
				this.resizeObserver.observe(gridElement);
			}

			let storedLayout = localStorage.getItem('item-layout');

			if (storedLayout) {
				this.layout = storedLayout;
			}

		},
		beforeUnmount() {
			// Clean up
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
			if (this.resizeTimeout) {
				clearTimeout(this.resizeTimeout);
			}
		}
	};

	Adzuki.VueComponents.AdzukiSelectFiles = component;

}(jQuery, window.Adzuki || {}));
